import { grayScale, pink } from "@enkor/design/colors";
import { StarIcon } from "@enkor/design/icons";

import * as S from "./StarRatingIndicator.style";

interface StarRatingIndicatorProps {
  rating: number;
  size?: number;
  activeColor?: string;
  inactiveColor?: string;
}

const StarRatingIndicator = ({
  rating,
  size = 22,
  activeColor = pink.main,
  inactiveColor = grayScale[600],
}: StarRatingIndicatorProps) => {
  const getStarColor = (starIndex: number) => {
    return starIndex < rating ? activeColor : inactiveColor;
  };

  return (
    <S.Container>
      {[1, 2, 3, 4, 5].map((star, index) => (
        <StarIcon
          key={star}
          size={size}
          fillColor={getStarColor(index)}
          strokeColor="transparent"
        />
      ))}
    </S.Container>
  );
};

export default StarRatingIndicator;
